<template>
    <!--评委要求澄清与答复记录-->
    <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
            <span>{{title}}</span>
        </div>
        <template>
            <p><span>投标人列表：</span> <span style="margin-left: 123px">评标专家：</span></p>

                <div class="leftTree" :style="{height:treeHeight}">

                        <el-tree
                                :data="treeData"
                                v-loading="dataListLoading"
                                node-key="code"
                                ref="tree"
                                empty-text="暂无评委数据"
                                :props="cusProps"
                                default-expand-all
                                :highlight-current="true"
                                @node-click="handleTreeNodeClick"
                                :expand-on-click-node="true">
                          <span class="custom-tree-node" slot-scope="{ node }">
                            <span>
    <!--                            <img v-if="!node.isLeaf" :src="userImg" class="iconImg" alt="">-->
                                <!--                            <i v-if="!node.isLeaf" class="el-icon-user-solid"></i>-->
                                <!--                            <img v-if="node.isLeaf" :src="documentImg" class="iconImg" alt="">-->
                                {{ node.label }}
                            </span>
                          </span>
                        </el-tree>
                </div>


            <div class="rightTable">
                <el-radio-group style="margin-bottom: 10px" v-model="getScoreListParams.profCode" size="small" @change="profChange">
                    <el-radio-button class="radioButton" v-for="(item,index) in professorListCopy" :key="index" :label="item.code">{{item.name}}</el-radio-button>
                </el-radio-group>
                <el-table
                        :data="tableDataCopy"
                        border
                        v-loading="dataListLoading">
                    <el-table-column fixed label="序号" type="index" :index="indexMethodNoPage" width="50" align="center"></el-table-column>
                    <el-table-column
                            prop="evalNode"
                            label="评分点"
                            header-align="center"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="evalTypeName"
                            label="评分点类型"
                            align="center"
                            width="96">
                    </el-table-column>
                    <el-table-column
                            prop="evalScore"
                            align="center"
                            width="80"
                            label="评分分值">
                    </el-table-column>
                    <el-table-column
                            prop="confScore"
                            width="100"
                            align="center"
                            label="符合性评分">
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备注">
                    </el-table-column>
                </el-table>
            </div>
        </template>
    </el-card>

</template>

<script>
    export default {
        components: {

        },
        props:{
            nodeCode:{
                type:String,
                defalut:'GC00014'
            },
            title:{
                type:String,
                defalut:''
            },
            tableData:{
                type:Array,
                default:()=>([])
            },
            treeData:{
                type:Array,
                default:()=>([])
            },
            getScoreListParams:{
                type:Object,
                default:()=>({
                    profCode:'',
                    supplierCode:'',
                })
            },
            professorList:{
                type:Array,
                default:()=>([])
            },
            dataListLoading:{
                type:Boolean,
                defalut:false
            },

        },
        watch:{
            nodeCode:{
                immediate: true,
                handler (val) {
                    this.nodeCodeCopy = val
                },
                deep: true
            },
            professorList: {
                immediate: true,
                handler (val) {
                    this.professorListCopy = val
                },
                // 这里是关键，代表递归监听 demo 的变化
                deep: true
            },

            tableData: {
                immediate: true,
                handler (val) {
                    this.tableDataCopy = val
                },
                // 这里是关键，代表递归监听 demo 的变化
                deep: true
            },
        },
        data() {
            return {
                keywords:"",
                cusProps:{
                    children:'children',
                    label:'name',
                },
                pageSize:10,//每页条数
                pageIndex:1,//当前页
                tableDataCopy:[],
                professorListCopy:[],
                nodeCodeCopy:"",
                treeHeight: ( document.documentElement.clientHeight - 86 ) + "px",
            }
        },
        activated() {

        },
        methods: {

            setFirstNodeSelect(firstLeafNodeCode){
                let node = this.$refs.tree.getNode(firstLeafNodeCode);
                if (node) {
                    this.$refs.tree.setCurrentKey(node);
                }
            },

            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            indexMethodNoPage(index) {
                return index + 1
            },
            profChange(){
                this.$emit('update:getScoreListParams',this.getScoreListParams)
                this.$emit('queryCustomFormData',this.getScoreListParams,this.nodeCodeCopy)
            },
            handleTreeNodeClick( data, node, elem ){
                if(node.isLeaf){
                    this.getScoreListParams.supplierCode = node.data.code;
                    this.$emit('update:getScoreListParams',this.getScoreListParams)
                    this.$emit('queryCustomFormData',this.getScoreListParams,this.nodeCodeCopy)
                }
            },
        }


    }
</script>
<style lang="less" scoped>
    .leftTree{
        width:200px;
        float: left;
        border:1px solid #ebeef5;
        margin-bottom: 20px;
        margin-right: 10px;
        padding: 10px 0px;

        .iconImg{
            width: 14px;
        }


        /deep/ .el-tree-node__content {
            /deep/ .el-icon-folder {
                padding: 0;
                display: none;
            }
        }

        .el-tree--highlight-current {
            /deep/ .el-tree-node.is-current{
                >.el-tree-node__content{
                    background-color: #1965FF;
                    color:#FFFFFF;
                }
            }
        }

        ::v-deep.el-tree-node__content{
            &:hover{
                 background-color: #1965FF;
                 color:#FFFFFF;
             }
        }


        .custom-tree-node{
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }

        /deep/ span.is-leaf{
            padding:0 !important;
        }


    }

    .rightTable{
        width: calc(100% - 210px);float: right;
        .radioButton{
            margin: 4px 0px;
            .el-radio-button__inner{
                display: inline-block;
                border:1px solid #dcdfe6!important;
                border-right: 4px!important;
            }
        }

    }
</style>
